/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Router from 'vue-router';
import auth from './auth';
import main from './main';
import regulations from './regulations';
import homeworks from './homeworks';
import homework from './homework';
import forgotPassword from './forgot-password';
import contact from './contact';
import PageNotFound from '../views/PageNotFound.vue';
import PageError from '../views/PageError.vue';
// import WriteAccessCookie from '../views/WriteAccessCookie.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'Auth.Login' },
    },
    // placeholder view
    // {
    //   path: '/write-access-cookie',
    //   component: WriteAccessCookie,
    //   beforeEnter: (to, from, next) => {
    //     localStorage.setItem('access-token', '1');
    //     next();
    //   },
    // },
    contact,
    forgotPassword,
    auth,
    regulations,
    main,
    homeworks,
    homework,
    {
      path: '/error',
      name: 'Error',
      component: PageError,
      props: true,
      meta: {
        background: 'white',
        eggos: 'grey',
      },
    },
    {
      path: '*',
      name: 'NotFound',
      component: PageNotFound,
      props: true,
      meta: {
        background: 'white',
        eggos: 'grey',
      },
    },
  ],
});

export default router;
